import { styled } from "@mui/material/styles";
import SvgIcon from "@mui/material/SvgIcon";

const DEFAULT_ICON_COLOR = "var(--color-text-primary)";
const DEFAULT_ICON_SIZE = "var(--icon-size-xl)";

interface MaterialUiIconProps {
  iconColor?: string;
  iconSize?: string;
  iconHoverColor?: string;
}

export const MaterialUiIcon = styled(SvgIcon, {
  shouldForwardProp: (prop) => prop !== "iconColor" && prop !== "iconSize" && prop !== "iconHoverColor",
})<MaterialUiIconProps>(({ iconColor, iconSize, iconHoverColor }) => ({
  color: iconColor ?? DEFAULT_ICON_COLOR,
  fontSize: iconSize ?? DEFAULT_ICON_SIZE,
  cursor: iconHoverColor ? "pointer" : "inherit",
  transition: iconHoverColor ? "color 0.3s ease-in-out" : undefined,
  "&:hover": iconHoverColor ? { color: iconHoverColor } : undefined,
}));

interface GetIconStyleProps {
  color?: string;
  hoverColor?: string;
  size?: string;
  isHovered?: boolean;
}

export function getIconStyle({ color, hoverColor, size, isHovered }: GetIconStyleProps) {
  return {
    color: isHovered && hoverColor ? hoverColor : (color ?? DEFAULT_ICON_COLOR),
    fontSize: size ?? DEFAULT_ICON_SIZE,
    cursor: hoverColor ? "pointer" : "inherit",
    transition: hoverColor ? "color 0.3s ease-in-out" : undefined,
    display: "inline-flex",
    verticalAlign: "middle",
    lineHeight: 0,
  };
}
